/**
 * RS shell — mobile menu, localization panel, cart count badge.
 */
(function () {
  const $ = (sel, root = document) => root.querySelector(sel);

  const initMobileMenu = () => {
    const toggle = $("#rs-menu-toggle");
    const menu = $("#rs-mobile-menu");
    const backdrop = $("#rs-menu-backdrop");
    if (!toggle || !menu) return;

    const panel = menu.querySelector(".mobile-menu__panel");
    const links = menu.querySelectorAll("a");

    const closeMenu = () => {
      menu.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", toggle.dataset.openLabel || "Open menu");
      document.body.classList.remove("menu-open");
      toggle.focus();
      window.setTimeout(() => {
        if (!menu.classList.contains("is-open")) menu.hidden = true;
      }, 400);
    };

    const openMenu = () => {
      menu.hidden = false;
      requestAnimationFrame(() => menu.classList.add("is-open"));
      toggle.setAttribute("aria-expanded", "true");
      toggle.setAttribute("aria-label", toggle.dataset.closeLabel || "Close menu");
      document.body.classList.add("menu-open");
      panel?.querySelector(".mobile-menu__link, a")?.focus();
    };

    toggle.addEventListener("click", () => {
      if (toggle.getAttribute("aria-expanded") === "true") closeMenu();
      else openMenu();
    });

    backdrop?.addEventListener("click", closeMenu);
    links.forEach((link) => link.addEventListener("click", closeMenu));

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && toggle.getAttribute("aria-expanded") === "true") {
        closeMenu();
      }
    });
  };

  const initLocalizationPanels = () => {
    document.querySelectorAll(".rs-shell .localization-picker").forEach((picker) => {
      document.addEventListener("click", (event) => {
        if (picker.open && !picker.contains(event.target)) {
          picker.open = false;
        }
      });

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && picker.open) {
          picker.open = false;
        }
      });
    });
  };

  const syncCartCountBadge = (count) => {
    document.querySelectorAll(".rs-shell cart-count").forEach((el) => {
      const n = typeof count === "number" ? count : Number(el.textContent) || 0;
      el.textContent = String(n);
      el.hidden = n === 0;
    });
  };

  const initCartCount = () => {
    document.querySelectorAll(".rs-shell cart-count").forEach((el) => {
      const n = Number(el.textContent) || 0;
      el.textContent = String(n);
      el.hidden = n === 0;
    });

    document.addEventListener("cart:change", (event) => {
      const count = event.detail?.cart?.item_count;
      if (typeof count === "number") syncCartCountBadge(count);
    });

    document.addEventListener("cart:refresh", async () => {
      try {
        const cart = await (await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`)).json();
        syncCartCountBadge(cart.item_count);
      } catch {
        /* ignore */
      }
    });
  };

  const setShellHeights = () => {
    const header = document.querySelector(".shopify-section-rs-header .site-header");
    const announcement = document.querySelector(".shopify-section-rs-announcement .announcement__viewport");

    if (header) {
      document.documentElement.style.setProperty("--header-h", `${header.offsetHeight}px`);
    }

    if (announcement) {
      document.documentElement.style.setProperty("--announcement-h", `${announcement.offsetHeight}px`);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initMobileMenu();
      initLocalizationPanels();
      initCartCount();
      setShellHeights();
    });
  } else {
    initMobileMenu();
    initLocalizationPanels();
    initCartCount();
    setShellHeights();
  }

  window.addEventListener("resize", setShellHeights);
})();
